import React from 'react';
import PropTypes from 'prop-types';

import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import DatePickerGenericField from '../../Common/DatePickerGenericField';

import { isDateValid, isReleaseDateValid } from './OfferDate.validation';
import { formatDate } from './utils';

const DateFieldsComponent = ({ formApi, strings, isLoan, readOnly }) => {
  const today = formatDate(new Date());

  return (
    <Grid className="grid dates" key="grid-date">
      {!isLoan ? <div className={Cell.getClassName({ size: 3 })} /> : undefined}
      <div key="date" className={Cell.getClassName({ size: 6 })}>
        <DatePickerGenericField
          type="date"
          className="field text"
          key="date"
          field="date"
          id="numberfield-date"
          name="date"
          shrink
          label={strings['block.offer.field.date.label']}
          errorLabel={strings['error.date']}
          placeholder="JJ/MM/AAAA"
          inputProps={{ min: today }}
          validation={isDateValid(today, strings)}
          required
          disabled={readOnly}
        />
      </div>
      {isLoan ? (
        <div key="release_date" className={Cell.getClassName({ size: 6 })}>
          <DatePickerGenericField
            type="date"
            className="field text"
            key="release_date"
            field="release_date"
            id="numberfield-release_date"
            name="release_date"
            shrink
            label={strings['block.offer.field.release_date.label']}
            errorLabel={strings['error.date']}
            placeholder="JJ/MM/AAAA"
            inputProps={{ min: get(formApi.getState(), 'values.date', today) }}
            validation={isReleaseDateValid(today, strings, formApi)}
            required
            disabled={readOnly}
          />
        </div>
      ) : undefined}
    </Grid>
  );
};

DateFieldsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  strings: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formApi: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  isLoan: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
};

DateFieldsComponent.defaultProps = {};

export default DateFieldsComponent;
